interface SkipLinkProps {
  targetId?: string;
  children?: React.ReactNode;
}

const SkipLink = ({ targetId = 'main-content', children = 'Skip to main content' }: SkipLinkProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="
        sr-only focus:not-sr-only
        fixed top-4 left-4 z-[100]
        px-4 py-2 bg-foreground text-background
        text-sm font-medium
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-foreground
        transition-transform duration-200
      "
    >
      {children}
    </a>
  );
};

export default SkipLink;
